import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   DeleteStrategiesvalues
export const DeleteStrategiesvalues = createSlice({
  name: "DeleteStrategiesvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    DeleteStrategiesvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_DeleteStrategiesvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_DeleteStrategiesvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    DeleteStrategiesvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_DeleteStrategiesvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchDeleteStrategiesvalues:(state)=>{
        state.switch = false
    }
  },
});
export default DeleteStrategiesvalues.reducer;
export const {
  DeleteStrategiesvalues_datagrid,
  success_api_call_DeleteStrategiesvalues_datagrid,
  failure_api_call_DeleteStrategiesvalues_datagrid,
  create_DeleteStrategiesvalues_datagrid_complete_api,
  DeleteStrategiesvalues_datagrid_is_success,false_switchDeleteStrategiesvalues
} = DeleteStrategiesvalues.actions;
